/**
 * This class models the liquid volume for a solution
 */
define([
    './SolventConcentrationSolutionModeler',
    './SpecieState'
], function (SolventConcentrationSolutionModeler, SpecieState) {
    var instance = null;
    function LiquidVolumeSolutionModeler () {
        // The default model used when no other model is selected
        this.DEFAULT = 0;

        // The NOMINALVOLUME model assumes the volume is the sum of the volumes
        // created to the solution.
        this.NOMINALVOLUME = 0;

        // The EVALUATED model assumes that the amount of water is properly set in
        // all solutions and then calculates the volume adding the volumes occupied
        // by each specie according to its density and amount
        //
        // All species with infinite amount are assumed ficticious and with no mass.
        this.EVALUATEDVOLUME = 1;

        // Stores the simulation model being used
        this.simulationModel = this.DEFAULT;
    }

    /**
     * Returns the liquid volume for this solution, static method
     *
     * @param s {Solution}
     *
     * @returns liquidVolume {Number}
     */
    LiquidVolumeSolutionModeler.prototype.getValue = function (s) {
        var liquidVolume = 0;

        // EVALUATEDVOLUME model
        if (this.simulationModel === this.EVALUATEDVOLUME) {

            if (SolventConcentrationSolutionModeler.simulationModel === SolventConcentrationSolutionModeler.SOLVENTFINITE) {
                // Sums the volume of species in the liquid phase
                var i;
                for (i = 0; i < s.getSpeciesCount(); i++) {
                    var sn = s.getSpeciesAt(i);

                    if (sn.archetype.state !== SpecieState.SOLID
                        && sn.archetype.state !== SpecieState.GAS
                        && !sn.infinite && sn.getDensity() !== 0) {
                        liquidVolume += sn.getWeight() / sn.getDensity() / 1000;
                    }
                }
            }
            else if (SolventConcentrationSolutionModeler.simulationModel === SolventConcentrationSolutionModeler.SOLVENTINFINITE) {
                // works as NOMINALVOLUME model if the model for water model
                // is not set to WATERFINITE
                liquidVolume = s.liquidVolume;
            }
        }

        // NOMINALVOLUME model
        else if (this.simulationModel === this.NOMINALVOLUME) {
            liquidVolume = s.liquidVolume;
        }
        return liquidVolume;
    };

    /**
     * Resets the default status
     */
    LiquidVolumeSolutionModeler.prototype.setDefault = function () {
        this.simulationModel = this.DEFAULT;
    };

    /**
     * Load the characteristics of the model from the problem file
     * @param model value of solutionModellers.liquidVolume from configuration
     */
    LiquidVolumeSolutionModeler.prototype.loadProperties = function (model) {
        if (model.toUpperCase() === "NOMINAL")
            this.simulationModel = this.NOMINALVOLUME;
        else if (model.toUpperCase() === "EVALUATED")
            this.simulationModel = this.EVALUATEDVOLUME;
    };

    LiquidVolumeSolutionModeler.getInstance = function() {
        if(instance === null) {
            instance = new LiquidVolumeSolutionModeler();
        }
        return instance;
    };
    return LiquidVolumeSolutionModeler.getInstance();
});
